import { Toggle } from "@/components/Toggle";
import type { UserRole } from "@/contexts/UserContext";
import { useUser } from "@/hooks/useUser";
import type { ReactNode } from "react";

export function RoleToggle({
  allowedRoles,
  allowed,
  denied,
  loading,
}: {
  readonly allowedRoles: UserRole[];
  readonly allowed: ReactNode;
  readonly denied: ReactNode;
  readonly loading?: ReactNode;
}) {
  const { user } = useUser();

  if (user === null && loading != null) {
    return loading;
  }

  return (
    <Toggle
      off={denied}
      on={allowed}
      showOn={
        user != null &&
        allowedRoles.find((role) => user.roles.includes(role)) != null
      }
    />
  );
}
